module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("footer_powered", [["p",{"class":"powered"},[["textNode",{"text":" Powered by "}],["a",{"href":"https://modelcentro.com?acode=&&0&&","rel":"nofollow"},[["textNode",{"text":"ModelCentro"}]],[["client.acode","href",false,[],"env"]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/footer/powered.tpl
// module id = 718
// module chunks = 4